module.exports = __webpack_public_path__ + "static/media/blue-right-arrow.43b08485.svg";